import axios from 'axios';
import router from '../router/index';
import globalConstants from '@/utils/global-constants.js';
import createPersistedState from 'vuex-persistedstate';


// Switch "base" for dev or production
const backendBase = `${globalConstants.BASE_URL}user/`;

const defaultbookMark = {
  title: 'default bookmark', 'dateCreated': '2019-07-30 12:53:10', 'dateUpdated': '2019-07-30 12:53:10', edit: false, 'hover': false, 'assets': ['AAPL', 'AMZN', 'FB', 'GS', 'WMT', 'BA'], 'apiname': 'News by Sentiment', 'type': '', 'fields': ['Sentiment', 'Title', 'Author', 'description', 'Source', 'Source Url', 'Published Time'], 'startDate': '7/24/2019', endDate: '7/29/2019'
};

export default {
  state: {
    pickedAccount: 'Pro',
    userFirstName: '',
    userLastName: '',
    userEmail: '',
    userPassword: '',
    // userApikey: '',
    userPlan: '',
    usage: 0,
    availableCredits: -1,
    overageCredits: 0,
    companyName: '',
    positionTitle: '',
    telephoneNumber: '',

    // tutorial states
    // showIntroTutorial: 0,
    // shouldShowIntroTutorial: false,

    cardFirstName: '',
    cardLastName: '',
    cardInfo: {},
    billingInvoice: [],
    subPeriodEnddate: '',
    planValue: 100,
    loading: false,
    formError: false,
    idToken: null,
    userId: null,
    user: null,
    verified: null,
    apikey: null,

    formStep: 3,
    farestStep: 3,
    region: 'US',

    // bookmarkList: [defaultbookMark],
    // resBookmarkJson: [],
    userDownloadHistories: [],
    clickedRow: '',
    exportBtnClicked: false,
  },

  plugins: [createPersistedState()],

  mutations: {
    authUser(state, userData) {
      console.log("[user-service] authUser() userData is: ", userData)
      state.idToken = userData.token || window.localStorage.getItem("token") || state.idToken;
      state.userEmail = userData.email || window.localStorage.getItem("email") || state.email;
      state.apikey = userData.apikey || window.localStorage.getItem("apikey") || state.apikey;
      state.userFirstName = userData.name.split(' ')[0] || window.localStorage.getItem("username").split(" ")[0] || state.userFirstName;
      state.userLastName = userData.name.split(' ')[1] || window.localStorage.getItem("username").split(" ")[1] || state.userLastName;
      state.userPlan = userData.plan || window.localStorage.getItem("userPlan") || 'free';
      // state.bookmarkList = userData.bookmarkList || state.bookmarkList;
      // state.showIntroTutorial = userData.showIntroTutorial || state.showIntroTutorial;
    },

    saveUserInfoInState(state, res) {
      const {
        cardInfo, firstname, lastname, accessKey, usage, invoice, currentPeriodEnddate,
        plan, overage, availableCredits, company, telephone, title, downloadHistories
      } = res;
      console.log("[user-service] saveUserInfoInState() res is: ", res);
      state.cardInfo = cardInfo;
      state.userFirstName = firstname || state.userFirstName;
      state.userLastName = lastname || state.userLastName;
      state.apikey = accessKey || state.apikey; // Blame Chenfeng
      state.usage = usage || state.usage;

      state.billingInvoice = invoice || state.billingInvoice;
      state.subPeriodEnddate = currentPeriodEnddate || state.subPeriodEnddate;
      state.userPlan = plan || state.userPlan || 'free';
      state.overageCredits = overage || state.overageCredits;
      state.availableCredits = availableCredits || state.availableCredits;

      state.companyName = company || state.companyName;
      state.telephoneNumber = telephone || state.telephoneNumber;
      state.positionTitle = title || state.positionTitle;

      state.userDownloadHistories = downloadHistories || state.userDownloadHistories;
    },

    storeUser(state, user) {
      state.user = user;
    },

    setUserFirstName(state, name) {
      state.userFirstName = name || state.userFirstName;
    },

    setUserLastName(state, name) {
      state.userLastName = name || state.userLastName;
    },

    setUserEmail(state, email) {
      state.userEmail = email;
    },

    setUserPassword(state, password) {
      state.userPassword = password;
    },

    setUserApikey(state, apikey) {
      state.apikey = apikey;
    },

    setCompanyName(state, name) {
      state.companyName = name || state.companyName;
    },

    setPositionTitle(state, title) {
      state.positionTitle = title || state.positionTitle;
    },

    setTelephone(state, telephone) {
      state.telephoneNumber = telephone || state.telephoneNumber;
    },

    setCardFirstName(state, name) {
      state.cardFirstName = name;
    },

    setCardLastName(state, name) {
      state.cardLastName = name;
    },

    setCardInfo(state, info) {
      state.cardInfo = info;
    },

    setPickedAccount(state, plan) {
      state.pickedAccount = plan;
    },

    setLoadingStatus(state, status) {
      state.loading = status;
    },

    setPlanValue(state, value) {
      state.planValue = value;
    },

    setUserPlan(state, type) {
      state.userPlan = type || 'free';
    },

    setOverageCredits(state, value) {
      state.overageCredits = value;
    },

    setBookMarkList(state, list) {
      state.bookmarkList = list;
    },

    setExportBtnClicked(state, boolean) {
      state.exportBtnClicked = boolean;
    },

    setClickedRow(state, title) {
      state.clickedRow = title;
    },

    clearAuthData(state) {
      state.idToken = null;
      state.userId = null;
      state.verified = null;
      state.companyName = '';
      state.positionTitle = '';
      state.telephoneNumber = '';

      state.billingInvoice = [];
      state.subPeriodEnddate = '';
      state.userPlan = '';
      state.apikey = '';
      state.usage = '';
      state.overageCredits = 0;
      state.availableCredits = 0;
      state.userDownloadHistories = [];
      state.bookmarkList = [defaultbookMark];
    },

    changeSubscriptionStatus(state, status) {
      state.billingInvoice.cancelAtPeriodEnd = status;
    },

    verifyUser(state) {
      state.verified = true;
    },

    resetFarestStep(state) {
      state.farestStep = 0;
    },

    goToStep(state, step) {
      state.formStep = step;
      state.farestStep = Math.max(step, state.farestStep);
    },

    goToNextStep(state) {
      state.formStep += 1;
      state.farestStep = Math.max(state.formStep, state.farestStep);
      state.formError = false;
    },

    goToLastStep(state) {
      state.formStep -= 1;
    },

    setFormError(state, hasError) {
      state.formError = hasError;
    },


    // Bookmark Mutations
    // addBookMark(state, bookmark) {
    //   state.bookmarkList.push(bookmark);
    // },

    // updateBookMark(state, payload) {
    //   const {
    //     bookmark,
    //     bookmarkName,
    //   } = payload;
    //   for (let idx = 0; idx < state.bookmarkList.length; idx++) {
    //     if (state.bookmarkList[idx].title === bookmarkName) {
    //       bookmark.dateCreated = state.bookmarkList[idx].dateCreated;
    //       state.bookmarkList[idx] = bookmark;
    //     }
    //   }
    // },

    // deleteBookmark(state, bookmarkName) {
    //   state.bookmarkList = state.bookmarkList.filter(el => el.title !== bookmarkName);
    // },

    // editBookmark(state, title) {
    //   state.bookmarkList.forEach((element) => {
    //     if (element.title == title) {
    //       element.edit = true;
    //     }
    //   });
    // },

    // tutorials
    // setShouldShowIntroTutorial(state, shouldShow) {
    //   state.shouldShowIntroTutorial = shouldShow;
    //   console.log('should show intro tutorial is: ', state.shouldShowIntroTutorial);
    // },

  },

  actions: {
    /**
     * Updated by Fangzhou
     */

    signup({
      commit,
      dispatch
    }, authData) {
      return axios.post(`${backendBase}regist`, authData);
    },

    paidSignup({
      commit,
      dispatch
    }, authData) {
      return new Promise((resolve, reject) => {
        axios.post(`${backendBase}paidregist`, authData)
          .then((res) => {
            // console.log('[user-service] success paidSignup(), res is: ', res);
            resolve(res);
          })
          .catch((err) => {
            // console.log('[user-service] failed paidSignup(), err.response.data.message is: ', err.response.data.message);
            reject(err.response.data.message);
          });
      });
    },

    subscripe({
      commit,
      dispatch
    }, authData) {
      return axios.post(`${backendBase}createsubscription`, authData);
      // return axios.post(`${localhost_PaymentBase}`, authData);
    },

    cancelSubscription({
      commit,
      dispatch
    }, data) {
      return axios.post(`${backendBase}cancelsubscription`, data);
    },

    activateSubscription({
      commit,
      dispatch
    }, data) {
      return axios.post(`${backendBase}activatesubscription`, data);
    },

    paidLogin({
      commit,
      dispatch
    }, authData) {
      return new Promise((resolve, reject) => {
        axios.post(`${backendBase}paidlogin`, authData)
          .then((res) => {
            // console.log('[user-service] success paidLogin(), res is: ', res);
            resolve(res);
          })
          .catch((err) => {
            console.log('[user-service] failed paidLogin(), err.response.data.message is: ', err.response.data.message);
            reject(err.response.data.message);
          });
      });
    },

    getProfile({
      commit, dispatch
    }, payload) {
      // eslint-disable-next-line indent
      return fetch(`${backendBase}profile`, {
        method: 'Get',
        headers: {
          Authorization: payload.token,
        },
      });
    },

    regenerateAccessKey({ commit, dispatch }, user) {
      return axios.post(`${backendBase}regenerateaccesskey`, user);
    },

    tryAutoLogin({ commit, dispatch }) {
      console.log("[user-service] tryAutoLogin()...")
      const token = window.localStorage.getItem('token');
      if (!token) return;

      const name = window.localStorage.getItem('username');
      const email = window.localStorage.getItem('email');

      const expirationDate = new Date(window.localStorage.getItem('expirationDate'));
      const now = new Date();

      if (now >= expirationDate) {
        dispatch('logout');
      } else commit('authUser', { token, name });
    },

    logout({
      commit,
    }) {
      commit('clearAuthData');
      window.localStorage.removeItem('expirationDate');
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('email');
      window.localStorage.removeItem('role');
      window.localStorage.removeItem('apikey');
      window.localStorage.removeItem('userPlan');
      window.localStorage.removeItem('showIntroTutorial');
      router.replace('/signin');
    },

    // called when redirect page
    verifyEmail({
      commit,
      dispatch,
    }, {
      token,
      mode,
    }) {
      return axios.post(`${backendBase}verify`, {
        token,
      });
    },

    verifyEnterprisePlan({
      commit,
      dispatch,
    }, formData) {
      return axios.post(`${backendBase}verifycompany`, formData);
      // return axios.post(`${localhost_PaymentBase}verify`, formData);
    },

    sendPasswordReset({
      commit,
      dispatch,
    }, email) {
      return axios.post(`${backendBase}passwordreset?email=${email}`);
    },

    updatePassword({
      commit,
      dispatch,
    }, data) {
      return axios.post(`${backendBase}passwordchange`, data);
    },

    login({
      commit,
      dispatch,
    }, authData) {
      return axios.post(`${backendBase}login`, authData);
    },

    validateForm({ commit }, payload) {
      let hasError = false;
      Object.values(payload).forEach((msg) => {
        if (msg) hasError = true;
      });
      commit('setFormError', hasError);
    },

    /**
     * User Bookmark Actions
     */

    // saveBookmark({
    //   commit,
    //   dispatch,
    // }, payload) {
    //   const {
    //     accessKey,
    //     newBookmark,
    //   } = payload;
    //   // const accesskey = payload.accessKey;
    //   // const bookJson = payload.newBookmark
    //   return axios.post(`${backendBase}addbookmark?AccessKey=${accessKey}`, newBookmark);

    // },

    // getAllBookmark({
    //   commit,
    //   dispatch,
    // }, accesskey) {
    //   return axios.get(`${backendBase}bookmark?AccessKey=${accesskey}`);
    // },

    // deleteBookmark({
    //   commit,
    //   dispatch,
    // }, payload) {

    //   const {
    //     accessKey,
    //     bookmarkName,
    //   } = payload;
    //   commit('deleteBookmark', bookmarkName);
    //   return axios.delete(`${backendBase}deletebookmark/${bookmarkName}?AccessKey=${accessKey}`);
    // },

    // getUserBookMarks({
    //   commit,
    //   dispatch,
    // }, accesskey) {

    //   dispatch("getAllBookmark", accesskey).then(response => {
    //     const bookmarkList = response.data.map(bm => {
    //       //  TODO:add all elements
    //       const assets = bm.assets.split(",");
    //       const indicators = bm.indicators.split("-");
    //       const apiname = indicators[0];
    //       const type = indicators[1];
    //       const fields = indicators[2].split(",");
    //       const dateRange = bm.dateRange.split("-");
    //       const startDate = dateRange[0];
    //       const endDate = dateRange[1];
    //       return {
    //         title: bm.bookmarkName,
    //         dateCreated: bm.bookmarkCreateDate,
    //         dateUpdated: bm.bookmarkUpdateDate,
    //         edit: false,
    //         hover: false,
    //         assets,
    //         apiname,
    //         type,
    //         fields,
    //         startDate,
    //         endDate
    //       };
    //     });
    //     commit("setBookMarkList", bookmarkList);
    //   })
    //     .catch(err => {
    //       console.log("getAllBookmark ERROR: ", err);
    //     });
    // },

    // updateBookmark({
    //   commit,
    //   dispatch,
    // }, payload) {
    //   const {
    //     accessKey,
    //     updatedBookmark,
    //     bookmarkName,
    //   } = payload;
    //   return axios.post(`${backendBase}updatebookmark/${bookmarkName}?AccessKey=${accessKey}`, updatedBookmark)
    //     .then((response) => {
    //       console.log(response);
    //     })

    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    // loadBookmark({ commit, dispatch }, payload) {

    //   const { bookmarkList, clickedRow } = payload;

    //   bookmarkList.forEach((bookmark) => {
    //     if (bookmark.title === clickedRow) {
    //       const {
    //         assets,
    //         apiname,
    //         type,
    //         fields,
    //         startDate,
    //         endDate,
    //       } = bookmark;

    //       console.log('type:', type, 'apiname:', apiname, 'fields:', fields);

    //       // check assets type
    //       if (assets[0].charAt(3) === '-') {
    //         // if user choose forex pairs eg CNY-USD
    //         const base = assets[0].split('-')[0];
    //         const targets = assets.map(pair => pair.split('-')[1]);
    //         const forexPairs = {
    //           base, targets, showBaseMenu: false, showTargetMenu: false
    //         };
    //         commit('setForexPairs', forexPairs);
    //         commit('setSelectedTickerList', assets);
    //       }
    //       else if (assets[0].includes('Data:')) {
    //         const ecInfo = assets[0].split(':');
    //         commit('setEcIndicatorDataArea', ecInfo[0].trim());
    //         commit('setEcIndicatorCategoryA', ecInfo[1].trim());
    //         commit('setEcIndicatorCategoryB', apiname);
    //       }

    //       commit('setSelectedTickerList', assets);

    //       commit('setSelectedApiType', type);
    //       commit('setSelectedIndicatorName', apiname);

    //       console.log('fields are : ', fields);
    //       commit('setApiSelectedFields', fields);
    //       commit('setDateRange', { startDate, endDate });

    //       // debugger;
    //     }
    //   });
    //   commit('setExportBtnClicked', 'true');
    // },

    updateUserInsInfo({ commit, dispatch }, payload) {
      return axios.post(`${backendBase}institution/info/update`, payload);
    },

    updateUserCard({ commit, dispatch }, payload) {
      return axios.post(`${backendBase}updateCard`, payload);
    },

    changeUserPassword({ commit, dispatch, }, payload) {
      return axios.post(`${backendBase}passwordchange`, payload);
    },

    linkedinOAuthLogin({ commit, dispatch }, payload) {
      const { code, redirect_url } = payload;
      console.log("url is: ", `${backendBase}login/linkedin?code=${code}&redirect_url=${redirect_url}`);
      return axios.post(`${backendBase}login/linkedin?code=${code}&redirect_url=${redirect_url}`)
    },

    googleOAuthLogin({ commit, dispatch }, payload) {
      const { code, redirect_url } = payload;
      return axios.post(`${backendBase}login/google?code=${code}&redirect_url=${redirect_url}`)
    },

    addDownloadHistory({ commit, state }, payload) {
      axios.post(`${backendBase}download`, payload)
        .then((res) => {
          state.userDownloadHistories.unshift(res.data);
        })
        .catch((err) => {
          console.log("[user-service] addDownloadHistory() ERROR: ", err);
        });
    },

    addSearchHistory({ commit, state }, payload) {
      const {
        accessKey,
      } = payload;
      axios.post(`${backendBase}search?accessKey=${accessKey}`, payload)
        .catch((err) => {
          console.log('[user-service] addSearchHistory() ERROR: ', err);
        });
    },

    // startIntroTutorial({ commit, state }) {
    //   // console.log("[user-service] startIntroTutorial(): starting... at route: ", this.$route);
    //   // post backend api (show_intro_tutorial + 1)
    //   axios.post(`${backendBase}start/introtutorial?accessKey=${state.userApikey}`);
    //   // .then(res => {
    //   //   // start tutorial
    //   //   console.log("startIntroTutorial() res is: ", res);
    //   // }).catch(err => {
    //   //   console.log("[user-service] startIntroTutorial() ERROR: ", err);
    //   // });
    //   commit('setShouldShowIntroTutorial', true);
    // },

    /**
     *  Insight Page Actions
     */

    addAssetSearchHistory({
      commit,
      state,
    }, payload) {
      const { t, ak } = payload;
      axios.post(`${backendBase}assetsearch?t=${t}&ak=${ak}`)
        .then((res) => {
          console.log('[user-service] addAssetSearchHistory() SUCCESS: ', res);
        })
        .catch((err) => {
          console.log('[user-service] addAssetSearchHistory() ERROR: ', err);
        });
    },
  },

  getters: {
    user(state) {
      return state.user;
    },

    isLogin(state) {
      return state.idToken !== null;
    },

    userApikey(state) {
      return state.apikey;
    },

    userFirstName(state) {
      return state.userFirstName;
    },

    userLastName(state) {
      return state.userLastName;
    },

    userEmail(state) {
      return state.userEmail;
    },

    userPassword(state) {
      return state.userPassword;
    },

    userPlan(state) {
      return state.userPlan;
    },

    companyName(state) {
      return state.companyName;
    },

    positionTitle(state) {
      return state.positionTitle;
    },

    telephone(state) {
      return state.telephoneNumber;
    },

    cardFirstName(state) {
      return state.cardFirstName;
    },

    cardLastName(state) {
      return state.cardLastName;
    },

    pickedAccount(state) {
      return state.pickedAccount;
    },

    planValue(state) {
      return state.planValue;
    },

    // shouldShowIntroTutorial(state) {
    //   return state.shouldShowIntroTutorial;
    // },
  },
};



// WEBPACK FOOTER //
// ./src/store/user-service.js